<div class="welcomeText">
    <h3 *ngIf="!priceComp" style="width: 100%;">{{dataJson["Ueberschrift"]}} <b><span>{{dataJson["UeberschriftStyle"]}}</span></b></h3>
    
    <div class="price-list" style="padding-top: 16px;">
        <div class="price-item" *ngFor="let item of priceList">
          <div class="item-description">{{item.description}}</div>
          <div class="item-price">{{item.price}}</div>
        </div>
      </div>
    <div class="TeamButton" style="padding-top: 50px;">
        <a *ngIf="!priceComp" aria-label="Preis-Seite" routerLink="/preise">{{ dataJson["Button"] }}</a>
    </div>
    
</div>